import React, {useEffect } from 'react'; 
import Header from "../Component/Header";
import { Link } from 'react-router-dom'
const PaymentFees = () => {
    useEffect(() => {
        document.title = 'Payment of Fees -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li> The Almanac  </li>
                 <li>School Rules</li>
                 <li>Payment of Fees</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Payment of Fees </h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <h6>School Fee</h6>
                    <ul className="list"> 
                    <li> Please quote your child's admission number during any kind of correspondence with the school. </li>

<li> <b> a)</b> School fee can be paid quarterly. The quarter begins from April 01, July 01, October 01 and Januray 01 respectively. The fee should be paid between the 1st and 10th of the first month of each quarter. In case of a holiday falling on 10th, the fee will be accepted on the next working day without late fee fine. For fee paid after the 10th of the first month of each quarter, a late fee fine of Rs 10/- per day will be charged.
 <br/>
  <b>b)</b> Fee can also be paid on monthly basis. Under monthly basis, parents are required to collect the fee slips at the school counter during the first week of every month. If the fee is paid after 10th of the respective month, the late fee fine of Rs 10/- per day shall be charged in addition to monthly fee.
 </li>
<li> Name of student will be stuck off without any intimation if the fee is not paid on the last day of the month. Further a re-admission fee of Rs 200/- will also be charged in addition to late fee fine. </li>

<li> Fee slips will be handed over to students during the first week of each quarter. In case of non-receipt of fee slips by the 7th of the first month of each qaurter please contact the Accounts Section. </li> 

<li> If the fee slip is dishonoured by the bank in any manner, the payment will be accepted in cash only at the school counter itself alongwith applicable late fee fine. Further bank charges of Rs 230/- or the charges prevailing at the time of payment will have to be paid separately. </li>

<li> Out station cheques will not be accepted. </li>

 {/*<li> The school fee is to be paid at the extension counter of the Syndicate Bank in the school premises from Monday to Friday between 0900 to 1300 hours and on Saturdays between 0900 to 1300 hours. The bank will be closed on 2nd and 4th Saturdays of every month. </li>   */}
                    </ul> 
                    <p>Cheques/drafts must be drawn in favour of, The Air Force School, Subroto Park, Delhi Cantt. You are also required to submit three copies of the fee slips.</p> 
<p>Fee slips are also available on school website at student's login.</p>
                    </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default PaymentFees